import type { FC, ReactNode } from 'react';
import React, { isValidElement } from 'react';

import { cnSlot } from './Slot.cn';
import { SlotContext } from './Slot.hooks/useSlotContext';
import type { SlotProps } from './Slot.types';

import './Slot.css';

export const Slot: FC<SlotProps> = ({
    className,
    children,
    hasDivider: hasDivider,
    hasInlineDivider: hasInlineDivider,
    gap = 's',
    padding = 's',
    hasPaddingLeft: paddingLeft = true,
    hasPaddingRight: paddingRight = true,
    hasMinWidth = true,
    isDisabled,
}) => {
    const items = React.Children.toArray(children);

    const renderItem = React.useCallback(
        (item: ReactNode, key: number) => (
            <span key={key} className={cnSlot('Item')}>
                {item}
            </span>
        ),
        [],
    );

    return (
        <SlotContext.Provider value={React.useMemo(() => ({ isDisabled }), [isDisabled])}>
            <div
                className={cnSlot(
                    {
                        hasDivider,
                        hasInlineDivider,
                        hasMinWidth,
                        gap,
                        padding,
                        paddingLeft,
                        paddingRight,
                        isDisabled,
                    },
                    [className],
                )}
            >
                {items.map((child, index) => {
                    // Фрагменты достаточно раскрывать только на первом уровне
                    if (isValidElement(child) && child.type === React.Fragment) {
                        return React.Children.toArray(child.props.children).map(
                            (innerChild, innerIndex) =>
                                renderItem(innerChild, index * items.length + innerIndex),
                        );
                    }
                    return renderItem(child, index);
                })}
            </div>
        </SlotContext.Provider>
    );
};
